export default __webpack_public_path__ + "static/media/Group 1ANTES-DEPOIIS.a7ad30fd.png";